import styled from "styled-components";

const FooterStyleWrapper = styled.footer`
  background: #131740;
  a {
    display: block;
    text-decoration: none;
    color: inherit;
  }
  p {
    margin-bottom: 0;
  }
  /* footer top  */
  .top-footer-content {
    padding-bottom: 90px;
    padding-top: 130px;
    border-top: 1px solid #FF06B7;
    .footer_image {
      padding-right: 55px;
      .footer-logo{
        display: flex;
        align-items: center;
        gap: 10px;
      }
      p {
        margin-top: 45px;
        font-weight: 500;
        color: rgba(255, 255, 255);
      }
      span{
        color: #FFFFFF;
        font-size: 24px;
        font-weight: 700;
      }
    }

    .footer-menu {
      .menu-title {
        color: #FF06B7;
        margin-bottom: 45px;
      }
      ul {
        margin: 0;
        padding: 0;

        li {
          line-height: 45px;
          a {
            color: rgba(255, 255, 255);
            transition: 0.4s;
          }
        }

        li:hover a {
          color: #FF06B7;
        }
      }
    }

    .footer_newsletter {
      .form-box {
        position: relative;
      }
      input,
      button {
        height: 60px;
        &:focus {
          outline: none;
        }
      }

      input {
        width: 100%;
        background: transparent;
        border: 2px solid #fff;
        color: rgba(255, 255, 255);
        line-height: 60px;
        padding: 0 20px;
      }

      .bottom_footer_right{
        margin-top: 20px;
        ul {
          display: flex;
          gap: 20px;
          li {
            a {
              display: block;
              width: 40px;
              height: 40px;
              line-height: 36px;
              text-align: center;
              background: #FF06B7;
              border-radius: 50%;
              transition: 0.4s;
              color: #fff;
            }
          }
       }

      }

      button {
        height: 100%;
        width: 70px;
        position: absolute;
        right: 0;
        background: #FF06B7;
        border: 2px solid #FFF;
        transition: all 0.3s;
        img {
          color: #FFF;
        }
        &:hover {
          background-color: #FF06B7;
        }
      }
    }
  }

  @media only screen and (max-width: 991px) {
  .footer-menu{
      .menu-title{
        margin-top: 20px;
      }
    }
  }

  @media only screen and (max-width: 768px) {
    .top-footer-content{
      padding-top:60px;
      
    .footer_image{
      p {
        margin-top: 30px;
     }
    }

    .footer-menu{
      .menu-title{
        margin-bottom: 32px;
      }
    }
  }
  }
  @media only screen and (max-width: 667px) { 
    .top-footer-content{
 

    .footer-menu{
      .menu-title{
        margin-bottom: 32px;
      }
    }

    .footer_newsletter{
      margin-top: 30px;
      padding-right: 50px;
    }
  }
  }
  @media only screen and (max-width: 540px) { 

    .top-footer-content{
      padding-top: 60px;
      
      .link-widgets{
        width: 50%;
      }
 
  }
  }
  @media only screen and (max-width: 375px) { 
    .top-footer-content{
 
      .footer_newsletter{
        padding-right:0;
      }
 
  }
  }
`;

export default FooterStyleWrapper;
